import { render } from "./SelectionModal.vue?vue&type=template&id=6e0a8e48&ts=true"
import script from "./SelectionModal.vue?vue&type=script&lang=ts"
export * from "./SelectionModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__